<template>
  <button type="button" @click="$emit('select', company.id)" :aria-current="selected ? 'true' : undefined"
    class="relative w-full text-left flex gap-2.5 px-3 py-2 transition-colors focus:outline-none focus-visible:bg-gray-50 dark:focus-visible:bg-gray-800/50"
    :class="selected ? 'bg-blue-50/60 dark:bg-blue-900/10' : 'hover:bg-gray-50 dark:hover:bg-gray-800/40'">
    <span class="absolute left-0 inset-y-0 w-0.5 transition-colors" :class="selected ? 'bg-blue-600 dark:bg-blue-400' : 'bg-transparent'" aria-hidden="true"></span>

    <JobAvatar :name="company.name || host" :src="company.logo_url" size="sm" class="mt-0.5" />

    <div class="min-w-0 flex-1">
      <h3 class="text-[13px] font-semibold leading-snug truncate" :class="selected ? 'text-blue-700 dark:text-blue-300' : 'text-gray-900 dark:text-white'">
        {{ company.name || slug }}
      </h3>
      <p class="text-xs text-gray-600 dark:text-gray-300 truncate">{{ subtitle }}</p>

      <div class="flex flex-wrap items-center gap-x-2 gap-y-0.5 mt-1 text-[11px] leading-4 text-gray-400 dark:text-gray-500">
        <span v-if="!company.linkedin_fetched" class="px-1.5 rounded-full text-[10px] font-semibold bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400">Waiting to be fetched</span>
        <span v-if="company.blocked_at" class="px-1.5 rounded-full text-[10px] font-semibold bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-400">Blocked</span>
        <span v-if="company.kind === 'recruiter'" class="px-1.5 rounded-full text-[10px] font-semibold bg-violet-50 dark:bg-violet-900/20 text-violet-700 dark:text-violet-300">Recruiter</span>
        <span class="tabular-nums">{{ company.jobs_count }} {{ company.jobs_count === 1 ? 'job' : 'jobs' }}</span>
        <span v-if="company.website_status === 'fetched'" class="px-1.5 rounded text-[10px] font-semibold bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-400">Website read</span>
      </div>
    </div>
  </button>
</template>

<script setup>
import { computed } from 'vue'
import JobAvatar from './JobAvatar.vue'

const props = defineProps({
  company: { type: Object, required: true },
  selected: { type: Boolean, default: false },
})
defineEmits(['select'])

// A company that has not been fetched has no name yet, so it is shown by the end of its LinkedIn address.
const slug = computed(() => props.company.linkedin_url?.match(/\/company\/([^/]+)/)?.[1] || 'Company')
const host = computed(() => props.company.website_url?.replace(/^https?:\/\/(www\.)?/, '').split('/')[0] || '')
const subtitle = computed(() => [props.company.industry, props.company.headquarters, props.company.size].filter(Boolean).join(' · ') || host.value || 'No details yet')
</script>
